import { LUDO_SOUND_FILES, LUDO_SOUND_MAX_MS, LUDO_SOUND_VOLUME } from './ludoSoundConfig.js';

let muted = false;
const audioCache = new Map();

function soundBaseUrl() {
  const base = process.env.PUBLIC_URL || '';
  return `${base}/sounds/ludo/`;
}

function resolveFile(key) {
  const file = LUDO_SOUND_FILES[key];
  if (file) return file;
  return LUDO_SOUND_FILES.click;
}

function getSource(key) {
  const file = resolveFile(key);
  const url = `${soundBaseUrl()}${file}`;
  if (!audioCache.has(url)) {
    const audio = new Audio(url);
    audio.preload = 'auto';
    audioCache.set(url, audio);
  }
  return audioCache.get(url);
}

/** Call on first user tap so mobile browsers allow playback. */
export function unlockLudoAudio() {
  Object.entries(LUDO_SOUND_FILES).forEach(([key, file]) => {
    if (!file) return;
    try {
      getSource(key).load();
    } catch {
      /* ignore */
    }
  });
}

export function setLudoSoundMuted(nextMuted) {
  muted = nextMuted;
}

export function isLudoSoundMuted() {
  return muted;
}

function playSound(key) {
  if (muted) return;

  const volume = LUDO_SOUND_VOLUME[key] ?? 1;
  const maxMs = LUDO_SOUND_MAX_MS[key] ?? 1000;
  const file = resolveFile(key);
  const url = `${soundBaseUrl()}${file}`;

  const audio = new Audio(url);
  audio.volume = Math.min(1, Math.max(0, volume));

  const stop = () => {
    audio.pause();
    audio.currentTime = 0;
  };

  audio.play().catch(stop);

  window.setTimeout(stop, maxMs);
}

export function playDiceClick() {
  unlockLudoAudio();
  playSound('click');
}

export function playDiceTick() {
  if (!LUDO_SOUND_FILES.tick) return;
  playSound('tick');
}

export function playDiceLand() {
  if (!LUDO_SOUND_FILES.land) return;
  playSound('land');
}

export function playTokenDie() {
  if (!LUDO_SOUND_FILES.tokenDie) return;
  playSound('tokenDie');
}

export function playSafePlace() {
  if (!LUDO_SOUND_FILES.safePlace) return;
  playSound('safePlace');
}

export function playMovingToken() {
  if (!LUDO_SOUND_FILES.movingToken) return;
  unlockLudoAudio();
  playSound('movingToken');
}

export function playDiceWinning() {
  if (!LUDO_SOUND_FILES.diceWinning) return;
  unlockLudoAudio();
  playSound('diceWinning');
}
